import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { KioskPinPad } from '../components/time/KioskPinPad';
/**
 * Kiosk-only view - PUBLIC ROUTE
 *
 * This page is a standalone interface with NO admin context:
 * - No sidebar
 * - No header
 * - No authentication required
 * - Just the PIN pad for employees to clock in/out
 *
 * Workflow:
 * 1. Admin enables kiosk mode at /settings/kiosk-setup
 * 2. System creates session and redirects here
 * 3. Admin tokens are cleared
 * 4. This page shows only PIN pad (fullscreen)
 */
export default function KioskOnlyPage() {
    return (_jsx("div", { className: "min-h-screen bg-gray-50 flex items-center justify-center p-4", children: _jsxs("div", { className: "w-full max-w-md", children: [_jsxs("div", { className: "text-center mb-8", children: [_jsx("div", { className: "inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-600 text-white text-2xl font-bold mb-4", children: "LA" }), _jsx("h1", { className: "text-3xl font-bold text-gray-900 mb-2", children: "LALO HR" }), _jsx("p", { className: "text-gray-600", children: "Time Clock" })] }), _jsx(KioskPinPad, {}), _jsxs("div", { className: "mt-8 text-center text-xs text-gray-500", children: [_jsx("p", { children: "Secure time tracking with PIN authentication" }), _jsx("p", { className: "mt-1", children: "For assistance, contact your administrator" })] })] }) }));
}
